import suppliers from './suppliers'

export default [
  {
    path: '/purchase',
    name: 'purchase',
    meta: {
      authRequired: true
    },
    component: () => import('@/router/views/purchase/dashboard/index')
  },
  ...suppliers,
  {
    path: '/purchase/products',
    name: 'purchase.products',
    meta: {
      authRequired: true
    },
    props: {
      isPurchaseable: true
    },
    component: () => import('@/router/views/products/list/purchase.index')
  }
]
